import { School } from '@/shared/types/entities/School';
import { Filter } from '@/shared/types/table';
import { organizationOptions } from './masterData/options';

export const filterBased: Filter<School> = {
  downloaded: {
    label: '周知用',
    key: 'downloaded',
    name: 'downloaded',
    type: 'checkbox',
    value: false,
  },
  school_name: {
    type: 'text',
    key: 'school_name',
    label: '学校名称',
    name: 'organization_name',
    value: undefined,
  },
  school_type: {
    type: 'select',
    key: 'school_type',
    label: '学校区分',
    name: 'organization_id',
    value: undefined,
    options: organizationOptions,
  },
  status: {
    type: 'checkbox',
    key: 'status',
    label: '状態',
    name: 'status',
    value: false,
  },
  productionAt: {
    type: 'date',
    key: 'productionAt',
    label: '公開期間(本番)',
    name: 'production_start',
    value: undefined,
    rangeProps: {
      label: '公開期間(本番)',
      name: 'production_end',
      value: undefined,
    },
  },
  rehearsalAt: {
    type: 'date',
    key: 'rehearsalAt',
    label: '公開期間(リハーサル)',
    name: 'rehearsal_start',
    value: undefined,
    rangeProps: {
      label: '公開期間(リハーサル)',
      name: 'rehearsal_end',
      value: undefined,
    },
  },
  is_enabled: {
    type: 'checkbox',
    key: 'is_enabled',
    label: '有効/無効',
    name: 'is_enabled',
    value: undefined,
    options: [
      { label: '無効', value: 0 },
      { label: '有効', value: 1 },
    ],
  },
};

export type SchoolListFilter = Pick<
  Filter<School>,
  'school_name' | 'rehearsalAt' | 'productionAt' | 'status'
>;

export type StatusListFilter = Pick<
  Filter<School>,
  'school_name' | 'rehearsalAt' | 'productionAt' | 'downloaded'
>;

export type AdminSchoolListFilter = Pick<
  Filter<School>,
  'school_name' | 'is_enabled'
>;

// filterBasedを参照すると初期化できないため、全く異なるObjectを作成しています。
export const schoolFilterFactory = () => {
  return {
    school_name: {
      type: 'text',
      key: 'school_name',
      label: '学校名称',
      name: 'organization_name',
      value: undefined,
    },
    status: {
      type: 'checkbox',
      key: 'status',
      label: '状態',
      name: 'status',
      value: false,
    },
    rehearsalAt: {
      type: 'date',
      key: 'rehearsalAt',
      label: '公開期間(リハーサル)',
      name: 'rehearsal_start',
      value: undefined,
      rangeProps: {
        label: '公開期間(リハーサル)',
        name: 'rehearsal_end',
        value: undefined,
      },
    },
    productionAt: {
      type: 'date',
      key: 'productionAt',
      label: '公開期間(本番)',
      name: 'production_start',
      value: undefined,
      rangeProps: {
        label: '公開期間(本番)',
        name: 'production_end',
        value: undefined,
      },
    },
    is_enabled: {
      type: 'checkbox',
      key: 'is_enabled',
      label: '有効/無効',
      name: 'is_enabled',
      value: undefined,
      options: [
        { label: '無効', value: 0 },
        { label: '有効', value: 1 },
      ],
    },
  } as SchoolListFilter;
};

export const statusFilterFactory = () => {
  return {
    school_name: {
      type: 'text',
      key: 'school_name',
      label: '学校名称',
      name: 'organization_name',
      value: undefined,
    },
    downloaded: {
      label: '周知用',
      key: 'downloaded',
      name: 'downloaded',
      type: 'checkbox',
      value: false,
    },
    rehearsalAt: {
      type: 'date',
      key: 'rehearsalAt',
      label: '公開期間(リハーサル)',
      name: 'rehearsal_start',
      value: undefined,
      rangeProps: {
        label: '公開期間(リハーサル)',
        name: 'rehearsal_end',
        value: undefined,
      },
    },
    productionAt: {
      type: 'date',
      key: 'productionAt',
      label: '公開期間(本番)',
      name: 'production_start',
      value: undefined,
      rangeProps: {
        label: '公開期間(本番)',
        name: 'production_end',
        value: undefined,
      },
    },
  } as StatusListFilter;
};

export const adminSchoolFilterFactory = () => {
  return {
    school_name: {
      type: 'text',
      key: 'school_name',
      label: '学校名称',
      name: 'organization_name',
      value: undefined,
    },
    is_enabled: {
      type: 'checkbox',
      key: 'is_enabled',
      label: '有効/無効',
      name: 'is_enabled',
      value: undefined,
      options: [
        { label: '無効', value: 0 },
        { label: '有効', value: 1 },
      ],
    },
  } as AdminSchoolListFilter;
};

export const initialSchoolFilter: SchoolListFilter = {
  school_name: filterBased.school_name,
  status: filterBased.status,
  productionAt: filterBased.productionAt,
  rehearsalAt: filterBased.rehearsalAt,
};

export const initialStatusFilter: StatusListFilter = {
  school_name: filterBased.school_name,
  downloaded: filterBased.downloaded,
  productionAt: filterBased.productionAt,
  rehearsalAt: filterBased.rehearsalAt,
};
